
export const colorize=(pixelData,rgb:{R:number,G:number,B:number})=>{
  const {R,G,B}=rgb  
  // If there isn't pixelData, a pixelBlock, nor pixels, exit the function
    if (pixelData === null || pixelData.pixelBlock === null || pixelData.pixelBlock.pixels === null) {
      return;
    }
  
    // The pixelBlock stores the values of all pixels visible in the view
    let pixelBlock = pixelData.pixelBlock;
  
    // Get the min and max values of the data in the current view
    let minValue = pixelBlock.statistics[0].minValue;
    let maxValue = pixelBlock.statistics[0].maxValue;
  
    // The mask is an array that determines which pixels are visible to the client
    let mask = pixelBlock.mask;
  
    // The pixels visible in the view
    let pixels = pixelBlock.pixels;
  
    // The number of pixels in the pixelBlock
    let numPixels = pixelBlock.width * pixelBlock.height;
  
    // Calculate the factor by which to determine the red and blue
    // values in the colorized version of the layer
    let factor = 255.0 / (maxValue - minValue);
  
    // Get the pixels containing temperature values in the only band of the data
    let band1 = pixels[0];
  
    // Create empty arrays for each of the RGB bands to set on the pixelBlock
    let rBand = [];
    let gBand = [];
    let bBand = [];
  
    // Loop through all the pixels in the view
    for (let i = 0; i < numPixels; i++) {
      // Get the pixel value recorded at the pixel location
      let tempValue = band1[i];
      // Calculate the red value based on the factor
      let red = (tempValue - minValue) * factor;  
      // Sets a color between blue (lowest) and red (highest) in each band
      rBand[i] = R//255-(red + 25)
      gBand[i] = G//222;
      bBand[i] = B//33//255-red;
    }
      // Set the new pixel values on the pixelBlock (now three bands)
  pixelData.pixelBlock.pixels = [rBand, gBand, bBand];
  
  pixelData.pixelBlock.pixelType = "u8"; // u8 is used for color
}